import { gql } from '@apollo/client';

export const GET_PROJECT_EVM = gql`
  query GetProjectReportsAndRecipients($id: ID!) {
    baseProject(id: $id) {
      id
      name
      alias
      evm {
        id
        projectId
        projectInfo {
          statusUpdate
          scopeCompletionPercentage
          kickoffMeetingDate
          originalReleaseDate
          projectedReleaseDate
        }
        projectBudget {
          projectedBudgetHours
          budgetTotalHours
          budgetUsedHours
          budgetUsedPercentage
          budgetRemainingHours
          cpiBudget
          cpiBudgetProjectionHours
        }
        projectTimeline {
          timelineTotalBdays
          timelineUsedBdays
          timelineUsedPercentage
          timelineRemainingBdays
          cpiTimeline
          cpiTimelineProjectionBdays
        }
        lastUpdate
        charts {
          statusUpdate
          scopeCompletionPercentage
          cpiBudget
          budgetUsedHours
          cpiTimeline
        }
      }
    }
  }
`;
